import React, { useState } from 'react';
import './style.css';
import IMAGES_PATH from '../../../Images';

const Collapsible = ({
    title,
    children,
}: {
    title: string;
    children: React.ReactNode;
}) => {
    const [open, setOpen] = useState(false);

    return (
        <div className="collapsible">
            <div className="collapsible-header" onClick={() => setOpen(!open)}>
                <h4>{title}</h4>
                <img
                    src={IMAGES_PATH.ICON_CHEVRON}
                    alt="Toggle"
                    className={`arrow ${open ? 'open' : ''}`}
                />
            </div>
            {open && <div className="collapsible-body">{children}</div>}
        </div>
    );
};

export default Collapsible;
